module.exports = __webpack_public_path__ + "static/media/admin_manual.39a34625.pdf";